export { default } from "./GeniusStandardsRow";
